import { useMutation } from "@apollo/client";
import { updateMobileResponseMutation } from "../../util/mutation/mobileServices.mutation";

import Spinner from "@src/components/spinner";
import { useLazyQuery, useQuery } from "@apollo/client";
import { getPayLevelQuery } from "@src/util/query/paylevel.query";
import { getAgencies } from "@src/util/query/agency.query";
import { GetEmployeeRecord } from "@src/util/query/employee.query";
import { getReportTemplates } from '@src/util/query/reportTemplate.query';
import { getSitesQuery } from "@src/util/query/site.query";
import debounce from 'lodash/debounce';

import { CaretDownFilled} from "@ant-design/icons";

import { Form, Select, Row, Col, TimePicker, Input, Tag, message, DatePicker } from "antd";
import React, { useEffect,useCallback, useState } from "react";
import dayjs from "dayjs";
import Swal from "sweetalert2";
import { CustomScheduleModal } from "./newMobileResponse.modal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExternalLink } from "@fortawesome/free-solid-svg-icons";
import { GetKeyCurrentCustodianBySiteIdQuery } from "@src/util/query/keyRegister.query";

export const EditMobileTask = ({taskData, onClose})=>{


  const [form] = Form.useForm();
  const { Option, OptGroup } = Select;
  const site = Form.useWatch("siteId", form);


  const [updateMobileResponse, {loading: updateMobilerResponseLoading}] = useMutation(updateMobileResponseMutation);

  const handleSave = async () => {
    try{
      const values = await form.validateFields();

            
      let isBoth = ""
      if( dayjs(taskData?.startTime).isSame(values.startTime, 'day') && dayjs(taskData?.endTime).isSame(values.endTime, 'day')){
        isBoth = `
            <div style="
              display: flex;
              flex-direction: column;
              gap: 16px;
              text-align: left;
              padding: 8px 0;
            ">
            
              <div style="
                display: flex;
                flex-direction: column;
                gap: 8px;
                padding: 16px;
              " 
              class="drawer-outlined-btn"
              id="thisTask"
              onmouseover="this.style.transform='translateY(-2px)'; this.style.boxShadow='0 8px 16px rgba(102, 126, 234, 0.3)';"
              onmouseout="this.style.transform='translateY(0)'; this.style.boxShadow='none';">
                <div style=" font-weight: 600; font-size: 15px;">This Task Only</div>
                <div style=" font-size: 13px;">Only update the currently selected task</div>
              </div>
      
             
              <div style="
                display: flex;
                flex-direction: column;
                gap: 8px;
                padding: 16px;
              " 
              class="drawer-filled-btn"
              id="futureTasks"
              onmouseover="this.style.transform='translateY(-2px)'; this.style.boxShadow='0 8px 16px rgba(240, 147, 251, 0.3)';"
              onmouseout="this.style.transform='translateY(0)'; this.style.boxShadow='none';">
                <div style=" font-weight: 600; font-size: 15px;">All Future Tasks</div>
                <div style=" font-size: 13px;">This will update the template and impact future task</div>
              </div>
              
      
              
            </div>
          `; 
      }else{
        isBoth = `
            <div style="
              display: flex;
              flex-direction: column;
              gap: 16px;
              text-align: left;
              padding: 8px 0;
            ">
            
              <div style="
                display: flex;
                flex-direction: column;
                gap: 8px;
                padding: 16px;
              " 
              class="drawer-outlined-btn"
              id="thisTask"
              onmouseover="this.style.transform='translateY(-2px)'; this.style.boxShadow='0 8px 16px rgba(102, 126, 234, 0.3)';"
              onmouseout="this.style.transform='translateY(0)'; this.style.boxShadow='none';">
                <div style=" font-weight: 600; font-size: 15px;">This Task Only</div>
                <div style=" font-size: 13px;">Only update the currently selected task</div>
              </div>
      
    
              
            </div>
          `; 
      }

      const result = await Swal.fire({
        icon: 'question',
        title: "Update Recurring Task",
        html: isBoth,
        showConfirmButton: false,
        showCancelButton: false,
        focusConfirm: false,
        width: '440px',
        padding: '24px',
        background: '#fff',
        backdrop: 'rgba(0,0,0,0.4)',
        didOpen: () => {
          const thisBtn = Swal.getHtmlContainer()?.querySelector("#thisTask");
          const futureBtn = Swal.getHtmlContainer()?.querySelector("#futureTasks");
          const todayBtn = Swal.getHtmlContainer()?.querySelector("#todayTasks");
    
          thisBtn?.addEventListener("click", () => {
            Swal.close();
            onScopeSelect("this");
          });
          
          futureBtn?.addEventListener("click", async() => {
            Swal.close();
            const dateResult = await Swal.fire({
              title: "Select Effective Date",
              html: `
        
                <input
                    type="date"
                    id="stopDate"
                    class="swal2-input"
                    style="width:90%;margin:10px"
                    min="${new Date().toLocaleDateString('en-CA')}"
                />
        
               
        
        
              `,
            
              focusConfirm: false,
              showCancelButton: true,
              confirmButtonText: "Continue",
              confirmButtonColor: "#d33",
              cancelButtonColor: "#6c757d",
            
             
            
              preConfirm: () => {
                const date = document.getElementById("stopDate").value;
            
                if (!date) {
                  Swal.showValidationMessage("Please select a effective date");
                  return false;
                }
        
            
                return {
                  effectiveDate: date
                };
              }
            });
            
            if (!dateResult.isConfirmed) return;

            onScopeSelect("future", dateResult?.value?.effectiveDate);

  
          });
          
         
        },
      });
    }catch(err){
      message.error("Please fill mandatory fields")
    }
    
  
   
  };;


  const scheduleType = Form.useWatch("scheduleType", form);
  const startTime = Form.useWatch("startTime", form);


  const onScopeSelect = async (scope, effectiveDate) => {
    try {
      const values = await form.validateFields();
      const updatedTask = {
        // ...rest,
        ...values,
        taskId: taskData?._id,
        // reportTemplateId: taskData?.reportTemplateId,
        templateId: taskData?.templateId,
        siteId: JSON.parse(values?.siteId)?.siteId,
        startTime: values.startTime ? values.startTime.toISOString() : taskData.startTime,
        endTime: values.endTime ? values.endTime.toISOString() : taskData.endTime,
        scope: scope,
        effectiveDate: effectiveDate,
        frequencyDays: scheduleType=="ufn"? frequencyDays : "",
        scheduleDays: scheduleType=="ufn"? scheduleDays : ""
      };
      
      await updateMobileResponse({
        variables:{
          input: updatedTask,
        }
      });
      
      message.success('Task updated successfully');
      onClose();

    } catch (err) {

      message.error('Failed to update task');
    } finally {

    }
  };



  const {data: dutyTypeData, loading: dutyTypeLoading, refetchDutyType} = useQuery(getPayLevelQuery,{
    fetchPolicy: 'network-only',
  });

  const [getSites ,{data: siteData, loading:siteLoading, refetch}] = useLazyQuery(getSitesQuery);

  useEffect(()=>{
    if(!siteLoading && taskData?.siteId && !site && siteData?.sites?.sites){
      const siteDetail = siteData?.sites?.sites[0];
      const newSiteData = {
        siteId: taskData?.siteId,
        customerId: siteDetail?.customerDetail?._id,
      };
      if(siteDetail?.metadata?.supplierId){
        newSiteData["supplierId"] = siteDetail?.metadata?.supplierId;
      }
      if(siteDetail?.metadata?.currentsupplier){
        newSiteData["currentsupplier"] = siteDetail?.metadata?.currentsupplier;
      }

      form.setFieldValue("siteId",  JSON.stringify(newSiteData));
    }
  },[siteData?.sites?.sites, !siteLoading]);



  const handelSiteSearch = async (input) => {
    const data = getSites({
      variables: {
        input: {
          filters: {
            advanceFilter: [
              [{
                operator: "sitename",
                condition: "and",
                filter: "contain_exactly",
                filterValue: [input]
              }]
            ]
          },
          page: 1,
          pageSize: 5,
        }
      },
      fetchPolicy: 'cache-and-network'
    });
    
    
  };


  const handelSiteSearchById = async (input) => {
    const data = getSites({
      variables: {
        input: {
          filters: {
            advanceFilter: [
              [{
                operator: "_id",
                condition: "and",
                filter: "contain_exactly",
                filterValue: [input]
              }]
            ]
          },
          page: 1,
          pageSize: 5,
        }
      },
      fetchPolicy: 'cache-and-network'
    });
    
    
  };
  
  // Debounced version
  const debouncedSiteSearch = useCallback(
    debounce((input) => {
      handelSiteSearch(input);
    }, 500), // 500ms delay
    [] // dependencies
  );

  const empPay = {
    employee: "Employee Pay Rate",
    site: "Site Pay Rate",
    sitegroup: "SiteGroup Pay Rate",
    customer: "Customer Pay Rate"
  };

  const supplierPay = {
    site: "Site Pay Rate",
    supplier: "Supplier Pay Rate",
  };
  
  const billRate = {
    site: "Site Bill Rate",
    customer: "Customer Bill Rate",
  };
  



  const [getAgencyQuery, {data: agencyData, loading: agencyLoading}] = useLazyQuery(getAgencies);

  const [GetKeyCurrentCustodianBySiteId, {data: GetKeyCurrentCustodianBySiteIdData}] = useLazyQuery(GetKeyCurrentCustodianBySiteIdQuery);
 
  const handelSupplierSearch = async(input)=>{
    await getAgencyQuery(
        {fetchPolicy: 'cache-and-network',
            variables: {
                input: {
                    filters: {
                      advanceFilter: [
                        [{
                          operator: "suppliername",
                          condition: "and",
                          filter: "contain_exactly",
                          filterValue: [input]
                        }]
                      ]
                    },
                  page: 1,
                  pageSize: 5,
                }
            }
        }
    );
  };


  // Debounced version
  const debouncedSupplierSearch = useCallback(
    debounce((input) => {
        if(input?.length>2){
            handelSupplierSearch(input);
        }
    }, 500), // 500ms delay
    [] // dependencies
  );


  const [getEmployeeQuery, {data: employeeData, loading: employeeDataLoading}] = useLazyQuery(GetEmployeeRecord);

  const handelEmployeeSearch = async(input)=>{
    await getEmployeeQuery(
        {
            variables: {
                input: {
                    filters: null,
                    search: input,
                    page: 1,
                    pageSize: 5,
                }
            },
            fetchPolicy: 'cache-and-network'
        }
    );
  };

  const handelEmployeeSearchById = async(input)=>{
    await getEmployeeQuery(
        {
            variables: {
                input: {
                    filters: {
                      advanceFilter: [
                        [{
                          operator: "_id",
                          condition: "and",
                          filter: "contain_exactly",
                          filterValue: [input]
                        }]
                      ]
                    },
                    page: 1,
                    pageSize: 5,
                }
            },
            fetchPolicy: 'cache-and-network'
        }
    );
  };


  // Debounced version
  const debouncedEmployeeSearch = useCallback(
    debounce((input) => {
        if(input?.length>2){
            handelEmployeeSearch(input);
        }
    }, 500), // 500ms delay
    [] // dependencies
  );


  const {data: customerTemplateData, loading: customerTemplateLoading} = useQuery(getReportTemplates,{
    variables: {
        customerId: site? JSON.parse(site)?.customerId : null,
        isArchived: false
    },
    fetchPolicy: 'network-only',
    skip: !site || !JSON.parse(site)?.customerId
  });


  const {data: StandardcustomerTemplateData, loading: StandardcustomerTemplateLoading} = useQuery(getReportTemplates,{
      variables: {
          customerId: null,
          isArchived: false
      },
      fetchPolicy: 'network-only',
  });



  const handelSupplierSearchById = async(input)=>{
    await getAgencyQuery(
        {fetchPolicy: 'cache-and-network',
            variables: {
                input: {
                    filters: {
                      advanceFilter: [
                        [{
                          operator: "_id",
                          condition: "and",
                          filter: "contain_exactly",
                          filterValue: [input]
                        }]
                      ]
                    },
                  page: 1,
                  pageSize: 5,
                }
            }
        }
    );
  };



  const [scheduleDays, setScheduleDays] = useState([]);
  const [frequencyDays, setFrequencyDays] = useState(0);

  useEffect(()=>{
    if(taskData){
      
      handelSiteSearchById(taskData?.siteId);

      if(taskData?.supplierId){
        handelSupplierSearchById(taskData?.supplierId);
      }

      if(taskData?.employeeId){
        handelEmployeeSearchById(taskData?.employeeId)
      }

      form.setFieldsValue({

        dutyTypeId: taskData?.dutyTypeId,
        priority: taskData?.priority,
        dispatchMethod: taskData?.dispatchMethod,
        reportTemplateId: taskData?.reportTemplateId,
        employeeId: taskData?.employeeId,
        supplierId: taskData?.supplierId,
        scheduleType: taskData?.scheduleType,
        payRate: taskData?.payRate,
        startTime: dayjs(taskData?.startTime),
        billRate: taskData?.billRate,
        endTime: dayjs(taskData?.endTime),
        notes: taskData?.notes,
      });
      
      setFrequencyDays(taskData?.frequencyDays);
      setScheduleDays(taskData?.scheduleDays);

    }
  },[taskData]);


  const isDisabled = taskData?.status?.toLowerCase()=="completed" || taskData?.status?.toLowerCase()=="cancel" || taskData?.status?.toLowerCase()=="inprogress"



  useEffect(()=>{
    if(startTime && dayjs(startTime).isValid()){
      form.setFieldValue("endTime", dayjs(startTime).add(1, "hour"));
    }
  },[startTime]);


  const [customScheduleModel, setCustomScheduleModel] = useState(false);

  useEffect(()=>{
    if(site?.length>0){
      GetKeyCurrentCustodianBySiteId({
        variables:{
          siteId: JSON.parse(site)?.siteId
        },
        fetchPolicy: 'network-only'
      });
    }
  },[site]);

  useEffect(()=>{
    if(GetKeyCurrentCustodianBySiteIdData?.getKeyCurrentCustodianBySiteId?.response){
      const keyDetail = GetKeyCurrentCustodianBySiteIdData?.getKeyCurrentCustodianBySiteId?.response;
      if(keyDetail?.custodianType?.toLowerCase()=="supplier"){
        if((site && JSON.parse(site) && JSON.parse(site)?.supplierId) && JSON.parse(site)?.supplierId!==keyDetail?.custodianId){
          Swal.fire({
            icon: "error",
            title: "Supplier and Key Mismatch",
            html: `
              <div style="text-align:left; font-size:14px; line-height:1.5;">
                <p style="margin-bottom:12px;">
                  This action cannot continue because the selected supplier does not match the supplier linked to the assigned key.
                </p>
                <div style="background:#f8f9fa; padding:12px; border-radius:6px;">
                  <div style="margin-bottom:6px;">
                    <strong>Current Supplier:</strong> ${JSON.parse(site)?.currentsupplier}
                  </div>
                  <div>
                    <strong>Key Assigned To:</strong> ${keyDetail?.custodianDetail?.name}
                  </div>
                </div>
              </div>
            `,
            confirmButtonText: "Got it",
            confirmButtonColor: "#d33",
          });
        }
        else if((site && JSON.parse(site) && !JSON.parse(site)?.supplierId)){
          Swal.fire({
            icon: "error",
            title: "No Supplier Selected for This Site",
            html: `
              <div style="text-align:left; font-size:14px; line-height:1.5;">
                <p style="margin-bottom:12px;">
                  No supplier is currently selected for this site. Please select a supplier and come back to schedule a task for this site.
                </p>
                <div style="background:#f8f9fa; padding:12px; border-radius:6px;">
                  <div>
                    <strong>Note:</strong> This site's key group is already assigned to <strong>${keyDetail?.custodianDetail?.name}</strong>.
                  </div>
                </div>
              </div>
            `,
            confirmButtonText: "Got it",
            confirmButtonColor: "#d33",
          });
        }
      }
      else if((site && JSON.parse(site) && JSON.parse(site)?.supplierId) && keyDetail?.custodianType && keyDetail?.custodianType?.toLowerCase()!=="supplier"){
        Swal.fire({
          icon: "error",
          title: "Supplier and Key Assignment Mismatch",
          html: `
            <div style="text-align:left; font-size:14px; line-height:1.5;">
              <p style="margin:0 0 12px 0;">
                This action cannot continue because the site has a supplier assigned, but the selected key is currently assigned in-house.
              </p>
              <div style="background:#f8f9fa; border-radius:8px; padding:12px;">
                <div style="margin-bottom:8px;"><strong>Site Supplier:</strong> ${JSON.parse(site)?.currentsupplier}</div>
                <div><strong>Key Assignment:</strong> In-House</div>
              </div>
            </div>
          `,
          confirmButtonText: "Got it",
          confirmButtonColor: "#d33",
        });
      }
      else{
        if(keyDetail?.custodianType && keyDetail?.custodianType?.toLowerCase()=="in-house" || keyDetail?.custodianType && keyDetail?.custodianType?.toLowerCase()=="employee"){
          form.setFieldsValue({
            dispatchMethod:"employee"
          })
        }
      }
    }
  },[GetKeyCurrentCustodianBySiteIdData?.getKeyCurrentCustodianBySiteId?.response]);


  // useEffect(()=>{
  //   if( scheduleDays?.length==0 && frequencyDays==0 && !customScheduleModel){
  //     form.resetFields(["scheduleType"]);

  //   }
  // },[scheduleDays, frequencyDays, customScheduleModel]);



  return(
    updateMobilerResponseLoading?
    <div style={{display:'flex', justifyContent:'center'}}>
      <Spinner />
    </div>
    :
    <Form
      form={form}
      layout="vertical"
      // onFinish={(e) => console.log(e)}
      requiredMark={false}
      className="mobileResponseForm"
      style={{

        // background: '#f9fafb',
        // borderRadius: '8px',
        // border: '2px dashed #d1d5db',
        padding:'20px',
        overflow: 'auto',
      }}
    >


      <CustomScheduleModal 
        visible={customScheduleModel}
        onClose={()=>setCustomScheduleModel(false)}
        title={"Until Further Notice"}
        scheduleDays={scheduleDays}
        setScheduleDays={setScheduleDays}
        frequencyDays={frequencyDays}
        setFrequencyDays={setFrequencyDays}
        form={form}
      />


      <Row gutter={16}>
        
        <Col xs={24} md={12}>
          <Form.Item
            name="siteId"
            label="Site"
            rules={[
              { required: true, message: "Please select a site" },
            ]}
            
          >
            <Select
              className="custom-select"
              placeholder="Type to search site..."
              showSearch
              suffixIcon={<CaretDownFilled />}
              onSearch={debouncedSiteSearch}
              loading={siteLoading}
              filterOption={false} 
              disabled={isDisabled}
            >
              {siteLoading?
              
                  <Option>
                      <div style={{display:'flex', justifyContent:'center'}}>
                          <Spinner/>
                      </div>
                  </Option>
              :
                  siteData?.sites?.sites?.map((site)=>(
                      <Option value={JSON.stringify({siteId: site?._id, customerId: site?.customerDetail?._id, supplierId: site?.metadata?.supplierId, currentsupplier: site?.metadata?.currentsupplier})}>{site?.sitename}</Option>
                  ))
              }
            </Select>
          </Form.Item>
        </Col>

        <Col xs={24} md={12}>
          <Form.Item
            name="priority"
            label="Priority"
            rules={[
              { required: true, message: "Please select priority" },
            ]}
          >
              <Select
                  className="custom-select"
                  placeholder="Type to search priority..."
                  showSearch
                  suffixIcon={<CaretDownFilled />}
                  disabled={isDisabled}
              >
                  <Option value="high">
                  <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                      <div
                      style={{
                          width: 12,
                          height: 12,
                          borderRadius: "50%",
                          backgroundColor: "#FF4D4F",
                      }}
                      />
                      <span>High</span>
                  </div>
                  </Option>
              
                  <Option value="medium">
                  <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                      <div
                      style={{
                          width: 12,
                          height: 12,
                          borderRadius: "50%",
                          backgroundColor: "#FA8C16",
                      }}
                      />
                      <span>Medium</span>
                  </div>
                  </Option>
              
                  <Option value="low">
                  <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                      <div
                      style={{
                          width: 12,
                          height: 12,
                          borderRadius: "50%",
                          backgroundColor: "#52C41A",
                      }}
                      />
                      <span>Low</span>
                  </div>
                  </Option>
              </Select>
        

          </Form.Item>
        </Col>
      </Row>
      
      <Row gutter={16}>
        <Col xs={24} md={12}>
          <Form.Item
            name="dutyTypeId"
            label="Duty Type"
            rules={[
              { required: true, message: "Please select a duty type" },
            ]}
            disabled={isDisabled}
          >
            <Select
              className="custom-select"
              placeholder="Type to search duty types..."
              showSearch
              optionFilterProp="children"
              suffixIcon={<CaretDownFilled />}
              loading={dutyTypeLoading}
              disabled={dutyTypeLoading || isDisabled}

            >
              {/* mobile jobs: only duty types in the Mobile category (and the job's own, if an older one isn't) */}
              {dutyTypeData?.getPayLevel?.response?.filter((dutyType) => dutyType?.category === "mobile" || String(dutyType?._id) === String(taskData?.dutyTypeId))?.map((dutyTypeData) => (
                  <Option value={dutyTypeData?._id}>{dutyTypeData?.name}</Option>
              ))}
            </Select>
          </Form.Item>
        </Col>

        <Col xs={24} md={12}>
          <Form.Item
            name="dispatchMethod"
            label="Dispatch Method"
            rules={[
              { required: true, message: "Please select dispatch method" },
            ]}
          >
              <Select
                  className="custom-select"
                  placeholder="Select Dispatch Method"
                  showSearch
                  suffixIcon={<CaretDownFilled />}
                  disabled={isDisabled}
                  onChange={()=>{
                    form.resetFields(["payRate", "billRate"])
                  }}
              >
                  <Option value={"employee"}>In-House Mobile Officer</Option>
                  <Option value={"supplier"}>Supplier</Option>
              </Select>
          </Form.Item>
        </Col>
      </Row>

      
      <Row gutter={16}>
        <Col xs={24} md={12}>
          <Form.Item
            name="reportTemplateId"
            label="Report Template"
            rules={[
              { required: true, message: "Please select a report template" },
            ]}
          >
            <Select
              className="custom-select"
              placeholder="Select a report template..."
              showSearch
              suffixIcon={<CaretDownFilled />}
              disabled={!site || isDisabled}


            >
              <OptGroup label={"Standard Template"}>
              {
                  StandardcustomerTemplateData?.getReportTemplates?.response?.map((temp)=>(
                      <Option value={temp?._id}>{temp?.templatename}</Option>
                  ))
              }
              </OptGroup>
              

              <OptGroup label="Custom Template">
                  {
                      customerTemplateData?.getReportTemplates?.response?.map((temp)=>(
                          <Option value={temp?._id}>{temp?.templatename}</Option>
                      ))
                  }
              </OptGroup>


            </Select>
          </Form.Item>
        </Col>

        <Col xs={24} md={12}>

          {/* Conditional Field */}
          <Form.Item
              noStyle
              shouldUpdate={(prev, curr) =>
              prev.dispatchMethod !== curr.dispatchMethod
              }
          >
              {({ getFieldValue, resetFields }) => {
              const method = getFieldValue("dispatchMethod");

              if (!method) return null;

              // Reset opposite field safely
              if (method === "employee") {
                  resetFields(["supplierId", ]);
              } else {
                  resetFields(["employeeId"]);
              }

              return (
                  <Form.Item
                      name={method === "employee" ? "employeeId" : "supplierId"}
                      label={method === "employee" ? "Employee" : "Supplier"}
                      rules={[
                      {
                          required: true,
                          message:
                          method === "employee"
                              ? "Please select an employee"
                              : "Please select a supplier",
                      },
                      ]}
                  >
                      <Select
                          className="custom-select"
                          showSearch
                          placeholder={
                              method === "employee"
                              ? "Select an employee..."
                              : "Select a supplier..."
                          }
                          suffixIcon={<CaretDownFilled />}
                          onSearch={method=="employee"? debouncedEmployeeSearch : debouncedSupplierSearch}
                          filterOption={false} 
                          loading={employeeDataLoading || agencyLoading}
                          disabled={isDisabled}
                      >

                          {employeeDataLoading || agencyLoading?
                              <Option>
                                  <div style={{display:'flex', justifyContent:'center'}}>
                                      <Spinner />
                                  </div>
                              </Option>
                              :
                              method=="employee"?
                                  employeeData?.getEmployee?.response?.map((emp)=>(
                                      <Option value={emp?._id}>{emp?.firstname +" "+ (emp?.lastname || "")}</Option>
                                  ))

                              :
                                  <>
                                  {
                                    site && JSON.parse(site) && JSON.parse(site)?.supplierId &&
                                      <Option value={JSON.parse(site)?.supplierId}>
                                          
                                        <div style={{display:'flex', justifyContent:'space-between'}}>
                                          {JSON.parse(site)?.currentsupplier}
                                          <Tag style={{height:'20px'}}> Preferred Supplier </Tag>
                                        </div>
                                      </Option>
                                  }
                                  {

                                    
                                      agencyData?.agencies?.agencies?.map((agency)=>(
                                          <Option value={agency?._id}>{agency?.suppliername}</Option>
                                      ))
                                  }
                                  </>
                          }
                      </Select>

                      
                  </Form.Item>
              );
              }}
          </Form.Item>

        </Col>
        
      </Row>


      
      <Row gutter={16}>
        <Col xs={24} md={12}>
          
        
          <Form.Item
            name="scheduleType"
            label={
              <div style={{display:'flex', width:'100%'}}>
                <span>
                  Schedule Frequency &nbsp;
                </span>
                {
                  scheduleType=="ufn" &&
                  <div style={{cursor:'pointer'}}
                  className="link"
                    onClick={()=>setCustomScheduleModel(true)}
                  >
                    
                    {
                      scheduleDays?.length>0 ? 
                      " ( " +
                      scheduleDays
                      ?.map(sd => {
                        return sd?.charAt(0).toUpperCase() + sd?.slice(1);
                      })
                      ?.join(" ")
                      +" )"

                      
                      :
                      " ( Repeat After Every " + frequencyDays + " days )"
                    }
                  </div>
                }
              </div>
            }
            rules={[
              { required: true, message: "Please select a schedule frequency" },
            ]}
            // className="scheduleTypeSearch"
            // style={{width:'100%'}}
          >
            <Select
                className="custom-select"
                placeholder="Select schedule frequency"
                suffixIcon={<CaretDownFilled />}
                disabled
            >

              <Option value="one-off">One-off </Option>
              <Option value="ufn">
                <span style={{ display: "flex", justifyContent: "space-between" }}>
                  Until further notice
                  <FontAwesomeIcon
                    icon={faExternalLink}
                    
                  />
                </span>
              </Option>

            </Select>

          </Form.Item>

        </Col>

        <Col xs={24} md={12}>
          <Form.Item
              noStyle
              shouldUpdate={(prev, curr) =>
              prev.dispatchMethod !== curr.dispatchMethod
              }
          >
              {({ getFieldValue, resetFields }) => {

                  const method = getFieldValue("dispatchMethod");
                  
                  return(
                      <Form.Item
                          name="payRate"
                          label="Pay Rate"
                          rules={[
                              { required: true, message: "Please select pay rate" },
                          ]}
                      >
                          

                          <Select
                              placeholder="Please select pay rate"
                              className="custom-select"
                              suffixIcon={<CaretDownFilled/>}
                              disabled={method === "employee"}
                          >
                              {
                                  method=="employee"?
                                  Object.entries(empPay)?.map(([key, label])=>(
                                      <Option value={key}>{label}</Option>
                                  ))
                                  :
                                  Object.entries(supplierPay)?.map(([key, label])=>(
                                      <Option value={key}>{label}</Option>
                                  ))
                              }


                          </Select>
                      
                      </Form.Item>
                  )
              
              }}
          </Form.Item>

        </Col>
      </Row>


      
      <Row gutter={16}>
        <Col xs={24} md={12}>
        {
          (taskData?.scheduleType=="one-off" || taskData?.frequencyDays>0 )?
          <Form.Item
            name="startTime"
            label="Start Time"
            rules={[
              { required: true, message: "Please enter start time" },
            ]}
          >

              <DatePicker
                  showTime
                  className="generic-input-control"
                  placeholder="Task start time"
                  format={"DD/MM/YYYY HH:mm"}
              />
            
          </Form.Item>

          :
          <Form.Item
            name="startTime"
            label="Start Time"
            rules={[
              { required: true, message: "Please enter start time" },
            ]}
          >

              <TimePicker
                  className="generic-input-control"
                  placeholder="Task start time"
                  format={"HH:mm"}
              />
            
          </Form.Item>
        }
        </Col>

        <Col xs={24} md={12}>
          <Form.Item
            name="billRate"
            label="Bill Rate"
            rules={[
              { required: true, message: "Please select Bill Rate" },
            ]}
          >
            <Select
              className="custom-select"
              placeholder="Type to search site..."
              showSearch
              suffixIcon={<CaretDownFilled />}
            >
              {
                  Object.entries(billRate)?.map(([key,label])=>(
                      <Option value={key}> {label} </Option>
                  ))
              }
            </Select>
          </Form.Item>
        </Col>
      </Row>


      
      <Row gutter={16}>
        <Col xs={24} md={12}>

        {
          (taskData?.scheduleType=="one-off" || taskData?.frequencyDays>0 )?
            <Form.Item
              name="endTime"
              label="End Time"
              rules={[
                { required: true, message: "Please enter end time" },
              ]}
            >
              <DatePicker
                showTime
                className="generic-input-control"
                placeholder="Task end time"
                format={"DD/MM/YYYY HH:mm"}
              />
            </Form.Item>

          :

            <Form.Item
              name="endTime"
              label="End Time"
              rules={[
                { required: true, message: "Please enter end tume" },
              ]}
            >
              <TimePicker
                className="generic-input-control"
                placeholder="Task end time"
                format={"HH:mm"}
              />
            </Form.Item> 
        }
          

          
        </Col>

        <Col xs={24} md={12}>
          <Form.Item
            name="notes"
            label="Additional Notes"
            rules={[
              { required: false, message: "Please enter additional notes" },
            ]}
          >
            <Input
              className="generic-input-control"
              placeholder="Additional Notes"
            />
          </Form.Item>
        </Col>
      </Row>


      <div 
      style={{display: 'flex', gap:'20px', flexDirection:'row-reverse', backgroundColor:'white'}}
      >
      <button className={updateMobilerResponseLoading? "drawer-outlined-btn disabled-btn": "drawer-filled-btn"} onClick={()=>{
          taskData?.scheduleType && taskData?.scheduleType=="one-off"? onScopeSelect("this") : handleSave()
      }}>Update</button>
      <button className={updateMobilerResponseLoading? "drawer-outlined-btn disabled-btn":"drawer-outlined-btn"}>Cancel</button>
      </div>

    </Form>





  )

  
}